import api from './axios';
import { ApiResponse, User } from '../types';

export type LoginPayload = {
  identifier: string;
  password: string;
};

export type RegisterPayload = {
  full_name: string;
  gender: string;
  father_name: string;
  mother_name: string;
  phone: string;
  whatsapp_number: string;
  email?: string;
  dob: string;
  division: string;
  district: string;
  upazilla: string;
  playing_role: string;
  batting_style: string;
  bowling_style?: string;
  nid?: string;
  password: string;
  jersey_size?: string;
};

export type AuthResponse = {
  token: string;
  user: User;
  isAdmin?: boolean;
  status?: string;
};

export type PendingAuthResponse = {
  status: 'PENDING';
  isAdmin?: boolean;
};

export type RegistrationResponse = {
  id: string;
  phone: string;
  status: string;
};

export const login = async (payload: LoginPayload) => {
  const response = await api.post<ApiResponse<AuthResponse | PendingAuthResponse>>('/api/v1/auth/login', payload);
  return response.data;
};

export const register = async (payload: RegisterPayload, profilePhoto?: File) => {
  const formData = new FormData();
  
  // Append all fields explicitly to ensure they're sent
  formData.append('full_name', payload.full_name);
  formData.append('gender', payload.gender);
  formData.append('father_name', payload.father_name);
  formData.append('mother_name', payload.mother_name);
  formData.append('phone', payload.phone);
  formData.append('whatsapp_number', payload.whatsapp_number);
  if (payload.email) {
    formData.append('email', payload.email);
  }
  formData.append('dob', payload.dob);
  formData.append('division', payload.division);
  formData.append('district', payload.district);
  formData.append('upazilla', payload.upazilla);
  formData.append('playing_role', payload.playing_role);
  formData.append('batting_style', payload.batting_style);
  if (payload.bowling_style) {
    formData.append('bowling_style', payload.bowling_style);
  }
  if (payload.nid) {
    formData.append('nid', payload.nid);
  }
  if (payload.jersey_size) {
    formData.append('jersey_size', payload.jersey_size);
  }
  formData.append('password', payload.password);
  
  // Add file if provided
  if (profilePhoto) {
    formData.append('profile_photo', profilePhoto);
  }
  
  const response = await api.post<ApiResponse<RegistrationResponse>>('/api/v1/auth/register', formData);
  return response.data;
};

export const verifyOtp = async (payload: { phone: string; otp: string }) => {
  const response = await api.post<ApiResponse<{ status: string }>>('/api/v1/auth/verify-otp', payload);
  return response.data;
};

export const getMe = async () => {
  const response = await api.get<ApiResponse<User>>('/api/v1/auth/me');
  return response.data;
};

export const logout = async () => {
  const response = await api.post<ApiResponse<{ success: boolean }>>('/api/v1/auth/logout');
  return response.data;
};

export const changePassword = async (currentPassword: string, newPassword: string) => {
  const response = await api.put<ApiResponse<{ success: boolean }>>('/api/v1/auth/change-password', {
    current_password: currentPassword,
    new_password: newPassword,
  });
  return response.data;
};

export const updateProfile = async (formData: FormData) => {
  const response = await api.put<ApiResponse<User>>('/api/v1/auth/profile', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};
